import axios from 'axios';
import dayjs from 'dayjs';

import IDnc from '../../../types/IDnc';
import IJobCandidateInteractionResponse from '../../CandidateSearchService/types/IJobCandidateInteractionResponse';
import CandidateDataDeleteRequestDTO from '../types/CandidateDataDeleteRequestDTO';
import CompanyGdprSettingsDTO from '../types/CompanyGdprSettingsDTO';
import DncLogSearchFilterDTO from '../types/DncLogSearchFilterDTO';
import GenerateOtpDTO from '../types/GenerateOtpDTO';

export const load = (link: string, workSpaceId: string) =>
  axios.get('candidatesearch/api/linkedcontacts/load', {
    params: {
      link: link,
      workspaceId: workSpaceId,
    },
  });

export const getCompanyGDPRSettings = () =>
  axios.get('candidatesearch/api/company-candidate-gdpr-settings/without-recruiter');

export const getCompanyGDPRSettingsByLoggedineRecruiter = () =>
  axios.get('candidatesearch/api/company-candidate-gdpr-settings/by-loggedin-recruiter');

export const getCompanyGDPRSettingsByRecruiter = (email: string) =>
  axios.get('candidatesearch/api/company-candidate-gdpr-settings/by-recruiter', {
    params: {
      email,
    },
  });

export const getDncLogByFilter = (payload: DncLogSearchFilterDTO) =>
  axios.post('api/dnclog/search-by-filter', payload);

export const saveCandidateDNCSettings = (payload: IDnc) =>
  axios.post('candidatesearch/api/candidate/dnc-settings', payload);

export const candidateDataDeleteRequest = (payload: CandidateDataDeleteRequestDTO) =>
  axios.post('candidatesearch/api/candidate-data-delete-requests', payload);

export const postCandidateGdprUpdateDetails = (details: IJobCandidateInteractionResponse) =>
  axios.post('/candidatesearch/api/candidate/gdpr/update-details', details);

export const getGDPRSettingsByID = (id: string) =>
  axios.get(`candidatesearch/api/company-candidate-gdpr-settings/${id}`);

export const postGDPRSettings = (gdprSettings: CompanyGdprSettingsDTO) =>
  axios.post(`candidatesearch/api/company-candidate-gdpr-settings`, gdprSettings);

export const getCandidateAccess = (candidateEmail: string, companyGdprId: string, otp: string) =>
  axios.get(`candidatesearch/api/candidate-gdpr-access/access`, {
    params: {
      candidateEmail: candidateEmail,
      companyGdprId: companyGdprId,
      otp: otp,
    },
  });

export const getCandidateDeleteRequest = (candidateEmail: string, companyGdprId: string) =>
  axios.get(`candidatesearch/api/candidate-data-delete-requests/by-email-and-gdpr-settings-id`, {
    params: {
      email: candidateEmail,
      companyGdprId: companyGdprId,
    },
  });

export const getUniqueInteractionInfo = (interactionId: string) =>
  axios.get(`candidatesearch/api/job-candidate-interactions/${interactionId}`);

export const putUpdatedCandidatedInfo = () => axios.post('candidatesearch/api/mapping');

export const putExpireOtpById = (id: string) =>
  axios.put(`/candidatesearch/api/candidate-gdpr-access/expire-otp`, id);

export const dataDeleteRequestList = (gdprSettingId: string, fromDate: string) =>
  axios.get(
    `candidatesearch/api/candidate-data-delete-requests/gdpr-settings-id/${gdprSettingId}/from-date/${dayjs(
      fromDate
    ).format('YYYY-MM-DD')}`
  );
export const postGenerateOtp = (otpBody: GenerateOtpDTO) =>
  axios.post(`/candidatesearch/api/candidate-gdpr-access/generate-otp`, otpBody);

export const flagCandidateDeleteRequestToProcessed = (candidateId: string) =>
  axios.put('candidatesearch/api/candidate-data-delete-requests/flag-as-processed', candidateId);

export const getCandidateDetailsForGDPR = (link: string, workSpaceID: string) =>
  axios.get(`candidatesearch/api/candidate/gdpr/candidate-details`, {
    params: {
      link,
      workSpaceID,
    },
  });
